const LOCAL_API_BASE_URL = 'http://127.0.0.1:8080';

const trimTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

export const resolveRuntimeApiBaseUrl = ({ apiUrl, nodeEnv } = {}) => {
  const resolvedApiUrl = apiUrl ?? process.env.REACT_APP_API_URL;
  if (resolvedApiUrl) {
    return trimTrailingSlash(resolvedApiUrl);
  }

  if ((nodeEnv ?? process.env.NODE_ENV) !== 'production') {
    return LOCAL_API_BASE_URL;
  }

  throw new Error('REACT_APP_API_URL is required for a production admin build');
};

export const API_BASE_URL = resolveRuntimeApiBaseUrl();

export default API_BASE_URL;
